import React, { useRef, useEffect, useState, useCallback } from "react";
import "./styles.css";
import ReactPlayer from "react-player";
import { videoSteps } from "./data";
import baseUrlNew from "../BaseUrl/index";
import axios from "axios";
import { useHistory } from "react-router-dom";
import video from "../assets/hatchback-v3-1104x828-30fps.webm";
import video_android from "../assets/hatchback-v3-1104x828-30fps.webm";
import NativeInspectionCamera from "../components/NativeInspectionCamera";
import { exitImmersiveMode } from "../utils/immersiveMode";
import { toast } from "react-toastify";

export default function CameraOverlay({ id, car_name }) {
  const history = useHistory();
  const [playVideo, setplayVideo] = useState(true);
  const [stepIndex, setStepIndex] = useState(0);
  const videoPlayer = useRef(null);
  const requestRef = useRef();
  const previousTimeRef = useRef(true);
  const arr = [].concat.apply([], Object.values(videoSteps));
  const guideUrl =
    window.navigator.platform === "iPhone" ? video : video_android;

  const seekToStep = useCallback(
    (index) => {
      const step = arr[index];
      if (!videoPlayer.current || !step) return;
      const t = Math.max(0, Number(step.start_at) || 0);
      try {
        videoPlayer.current.seekTo(t, "seconds");
      } catch {
        /* ignore */
      }
    },
    [arr]
  );

  useEffect(() => {
    previousTimeRef.current = playVideo;
  }, [playVideo]);

  const animate = () => {
    if (previousTimeRef.current && videoPlayer.current) {
      const step = arr[stepIndex];
      if (step) {
        const getCurrentTime = videoPlayer.current.getCurrentTime() || 0;
        const start = Number(step.start_at) || 0;
        const stop = Number(step.stop_at) || start;
        const reachedPose =
          stop <= start
            ? getCurrentTime >= start
            : getCurrentTime >= start && getCurrentTime <= stop + 0.2;
        if (reachedPose) {
          previousTimeRef.current = false;
          setplayVideo(false);
        }
      }
    }
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepIndex]);

  // Opening pose (0/0) — unlock capture quickly so the frame stays visible
  useEffect(() => {
    const step = arr[stepIndex];
    if (!step) return undefined;
    const start = Number(step.start_at) || 0;
    const stop = Number(step.stop_at) || 0;
    if (start === 0 && stop === 0) {
      const t = window.setTimeout(() => {
        previousTimeRef.current = false;
        setplayVideo(false);
        seekToStep(0);
      }, 400);
      return () => window.clearTimeout(t);
    }
    return undefined;
  }, [stepIndex, arr, seekToStep]);

  useEffect(() => {
    seekToStep(stepIndex);
  }, [stepIndex, seekToStep]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      const message =
        "Are you sure you want to leave? All provided data will be lost.";
      e.returnValue = message;
      return message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const baseUrl = `${baseUrlNew.baseUrl}api/v1/product_images/`;

  const PostCarimge = async (image, data) => {
    await axios.post(baseUrl, {
      name: data.title,
      type: data.type,
      image_data: image,
      evaluate_image: id,
    });
  };

  const goSteps = async () => {
    await exitImmersiveMode();
    history.push({
      pathname: "/inspection/carsteps",
      state: { id, car_name },
    });
  };

  const onCapture = async (imageSrc) => {
    try {
      await PostCarimge(imageSrc, arr[stepIndex]);
    } catch (err) {
      toast.error("Could not upload this photo. Please try again.");
      throw err;
    }

    if (stepIndex + 1 >= arr.length) {
      await goSteps();
      return;
    }

    const next = stepIndex + 1;
    setStepIndex(next);
    seekToStep(next);
    previousTimeRef.current = true;
    setplayVideo(true);
  };

  const step = arr[stepIndex] || {};
  const titleBar = `${stepIndex + 1} / ${arr.length} ${step.title || ""}`;

  return (
    <NativeInspectionCamera
      onCapture={onCapture}
      onCancel={goSteps}
      keepStreamAfterCapture
      captureEnabled={!playVideo}
      cancelLabel="Cancel"
      hint="Match the guide pose, then capture."
      rotateDescription="Hold your phone horizontally to capture vehicle photos. Cancel returns to steps."
      titleBar={titleBar}
      overlay={
        <div className="video_wrapper pi-camera-guide" style={{ pointerEvents: "none" }}>
          <ReactPlayer
            ref={videoPlayer}
            playing={playVideo}
            width="92%"
            height="92%"
            playsinline
            muted
            url={guideUrl}
            onReady={() => seekToStep(stepIndex)}
            config={{
              file: {
                attributes: {
                  playsInline: true,
                  muted: true,
                },
              },
            }}
          />
        </div>
      }
    />
  );
}
